import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtDateTime } from "../../lib/format";
import { Card } from "../common/UI";

export default function HistoryTab({ id, tick }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/measures/${id}/timeline`).then((r) => setData(r.data)); }, [id, tick]);
  if (!data) return <div className="text-xs text-slate-400">Loading…</div>;
  return (
    <div className="space-y-4">
      <Card title="Legislative history timeline" testId="workflow-timeline">
        <ol className="relative ml-2 border-l border-slate-200">
          {data.workflow.map((h) => (
            <li key={h.id} className="mb-5 ml-5" data-testid={`timeline-entry-${h.id}`}>
              <span className="absolute -left-[5px] mt-1.5 h-2.5 w-2.5 rounded-full border-2 border-white bg-sky-600" />
              <div className="text-xs font-semibold text-slate-800">{h.from_stage ? `${h.from_stage} → ${h.to_stage}` : h.to_stage}</div>
              <div className="text-[11px] text-slate-500">{h.actor} · {fmtDateTime(h.created_at)}</div>
              {h.reason && <div className="mt-1 rounded bg-slate-50 px-2 py-1 text-xs text-slate-600">{h.reason}</div>}
            </li>
          ))}
        </ol>
      </Card>
      {data.audit.length > 0 && (
        <Card title="Audit trail for this record" testId="measure-audit">
          <ul className="divide-y divide-slate-100">
            {data.audit.map((a) => (
              <li key={a.id} className="py-2 text-xs">
                <span className="font-mono text-[10px] text-sky-700">{a.action}</span> <span className="text-slate-700">{a.summary}</span>
                <div className="text-[10px] text-slate-400">{a.actor_email} · {fmtDateTime(a.created_at)}</div>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
}
